import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import React from 'react';
import { NotificationManager } from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import swal from 'sweetalert';

import {
	COMPLETE_REPORT_SUCCESS,
	COMPLETE_REPORT_ERROR,
	DECLINE_REPORT_SUCCESS,
	DECLINE_REPORT_ERROR,
	DELETE_REPORT_SUCCESS,
	DELETE_REPORT_ERROR,
	RESTORE_REPORT_SUCCESS,
	RESTORE_REPORT_ERROR,
	EDIT_REPORT_SUCCESS,
	EDIT_REPORT_ERROR,
	SET_REPORT_DEADLINE_SUCCESS,
	SET_REPORT_DEADLINE_ERROR,
	SET_REPORT_RESUBMISSION_SUCCESS,
	SET_REPORT_RESUBMISSION_ERROR,
	STOP_OBSERVING_REPORT_SUCCESS,
	STOP_OBSERVING_REPORT_ERROR,
	ASSIGN_REPORT_SUCCESS,
	ASSIGN_REPORT_ERROR,
	CREATE_NEW_REPORT_SUCCESS,
	CREATE_NEW_REPORT_ERROR,
	ADD_ORGANISATION_CONTACT_SUCCESS,
	ADD_ORGANISATION_CONTACT_ERROR,
	UPDATE_ORGANISATION_CONTACT_SUCCESS,
	UPDATE_ORGANISATION_CONTACT_ERROR,
	DELETE_ORGANISATION_CONTACT_ERROR,
	DELETE_ORGANISATION_CONTACT_SUCCESS,
	REPORT_CITIZEN_SUCCESS,
	REPORT_CITIZEN_ERROR,
	UPDATE_USER_PASSWORD_SUCCESS,
	UPDATE_USER_PASSWORD_ERROR,
	RESTORE_PASSWORD_ERROR,
	SIGNIN_USER_ERROR,
	COMMON_UPDATE_SUCCESS,
	COMMON_UPDATE_ERROR,
	TOKEN_EXPIRED,
	UPDATE_ORGANISATION_DATA_SUCCESS,
	UPDATE_ORGANISATION_DATA_ERROR,
	ADD_ORGANISATION_USER_SUCCESS,
	ADD_ORGANISATION_USER_ERROR,
	ADD_ORGANISATION_GROUP_SUCCESS,
	ADD_ORGANISATION_GROUP_ERROR,
	UPDATE_ORGANISATION_SETTINGS_SUCCESS,
	UPDATE_ORGANISATION_SETTINGS_ERROR,
	UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_SUCCESS,
	UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_ERROR,
	ADD_ORGANISATION_APP_USER_CONNECTION_SUCCESS,
	ADD_ORGANISATION_APP_USER_CONNECTION_ERROR,
	REMOVE_ORGANISATION_APP_USER_CONNECTION_SUCCESS,
	REMOVE_ORGANISATION_APP_USER_CONNECTION_ERROR,
	SHOW_NEW_REPORT_GET_ADDRESS_ERROR,
	COMMON_ERROR,
	REMOVE_ORGANISATION_USER_SUCCESS,
	COMMON_SUCCESS,
	CREATE_NEW_ISSUE_SUCCESS,
	CREATE_NEW_ISSUE_ERROR
} from 'constants/ActionTypes';

const connectionErrorNotification = error => {
	NotificationManager.error(<IntlMessages id="notifications.apiRequestFailed" />, <IntlMessages id="notifications.error.title" />, 5000, () => {
		swal({ text: JSON.stringify(error), dangerMode: true, icon: 'error' });
	});
};

const errorNotification = (messageId, error, errorTitle) => {
	NotificationManager.error(errorTitle ? errorTitle : <IntlMessages id={messageId} />, <IntlMessages id="notifications.error.title" />, 5000, () =>
		error ? swal({ text: JSON.stringify(error), dangerMode: true, icon: 'error' }) : console.log('')
	);
};

const successNotification = (text, textOnly) => {
	NotificationManager.success(textOnly ? text : <IntlMessages id={text} />);
};

const warningNotification = (title, subTitle, textOnly) => {
	NotificationManager.warning(textOnly ? subTitle : <IntlMessages id={subTitle} />, textOnly ? title : <IntlMessages id={title} />);
};

function* completeReportSuccess() {
	successNotification('notifications.report.complete.success');
}

function* completeReportError({ payload }) {
	errorNotification('notifications.report.complete.error', payload.error);
}

function* declineReportSuccess() {
	successNotification('notifications.report.decline.success');
}

function* declineReportError({ payload }) {
	errorNotification('notifications.report.decline.error', payload.error);
}

function* deleteReportSuccess() {
	successNotification('notifications.report.delete.success');
}

function* deleteReportError({ payload }) {
	errorNotification('notifications.report.delete.error', payload.error);
}

function* restoreReportSuccess() {
	successNotification('notifications.report.restore.success');
}

function* restoreReportError({ payload }) {
	errorNotification('notifications.report.restore.error', payload.error);
}

function* editReportSuccess() {
	successNotification('notifications.report.edit.success');
}

function* editReportError({ payload }) {
	errorNotification('notifications.report.edit.error', payload.error);
}

function* setReportDeadlineSuccess() {
	successNotification('notifications.report.setDeadline.success');
}

function* setReportDeadlineError({ payload }) {
	errorNotification('notifications.report.setDeadline.error', payload.error);
}

function* setReportResubmissionSuccess() {
	successNotification('notifications.report.setResubmission.success');
}

function* setReportResubmissionError({ payload }) {
	errorNotification('notifications.report.setResubmission.error', payload.error);
}

function* stopObservingReportSuccess() {
	successNotification('notifications.report.stopObserving.success');
}

function* stopObservingReportError({ payload }) {
	errorNotification('notifications.report.stopObserving.error', payload.error);
}

function* assignReportSuccess() {
	successNotification('notifications.report.assignReport.success');
}

function* assignReportError({ payload }) {
	errorNotification('notifications.report.assignReport.error', payload.error);
}

function* createNewReportSuccess() {
	successNotification('notifications.newReport.create.success');
}

function* createNewReportError({ payload }) {
	errorNotification('notifications.newReport.create.error', payload.error);
}

function* addOrganisationContactSuccess() {
	successNotification('notifications.organisationContact.add.success');
}

function* addOrganisationContactError({ payload }) {
	errorNotification('notifications.organisationContact.add.error', payload.error);
}

function* updateOrganisationContactSuccess() {
	successNotification('notifications.update.common.success');
}

function* updateOrganisationContactError({ payload }) {
	errorNotification('notifications.update.common.error', payload.error);
}

function* deleteOrganisationContactSuccess() {
	successNotification('notifications.organisationContact.delete.success');
}

function* deleteOrganisationContactError({ payload }) {
	errorNotification('notifications.organisationContact.delete.error', payload.error);
}

function* reportCitizenSuccess() {
	successNotification('citizenProfile.reportCitizen.success');
}

function* reportCitizenError({ payload }) {
	errorNotification('citizenProfile.reportCitizen.error', payload.error);
}
function* addOrganisationUserSuccess() {
	successNotification('notifications.organisationUser.add.success');
}

function* addOrganisationUserError({ payload }) {
	errorNotification('notifications.organisationUser.add.error', payload.error);
}

function* addOrganisationGroupSuccess() {
	successNotification('notifications.organisationGroup.add.success');
}

function* addOrganisationGroupError({ payload }) {
	errorNotification('notifications.organisationGroup.add.error', payload.error);
}

function* addOrganisationAppUserConnectionSuccess() {
	successNotification('organisationProfile.meldooAppSettings.addConnection.success');
}

function* addOrganisationAppUserConnectionError({ payload }) {
	errorNotification('organisationProfile.meldooAppSettings.addConnection.error', payload.error);
}

function* removeOrganisationAppUserConnectionSuccess() {
	successNotification('organisationProfile.meldooAppSettings.removeConnection.success');
}

function* removeOrganisationAppUserConnectionError({ payload }) {
	errorNotification('organisationProfile.meldooAppSettings.removeConnection.error', payload.error);
}

function* showNewReportGetAddressError({ payload }) {
	errorNotification('newReport.getAddressError', payload.error);
}

function* removeOrganisationUserSuccess() {
	successNotification('organisationProfile.users.deleteUser.success');
}

export function* reportNotifications() {
	yield takeEvery(COMPLETE_REPORT_SUCCESS, completeReportSuccess);
	yield takeEvery(COMPLETE_REPORT_ERROR, completeReportError);
	yield takeEvery(DECLINE_REPORT_SUCCESS, declineReportSuccess);
	yield takeEvery(DECLINE_REPORT_ERROR, declineReportError);
	yield takeEvery(DELETE_REPORT_SUCCESS, deleteReportSuccess);
	yield takeEvery(DELETE_REPORT_ERROR, deleteReportError);
	yield takeEvery(RESTORE_REPORT_SUCCESS, restoreReportSuccess);
	yield takeEvery(RESTORE_REPORT_ERROR, restoreReportError);
	yield takeEvery(EDIT_REPORT_SUCCESS, editReportSuccess);
	yield takeEvery(EDIT_REPORT_ERROR, editReportError);
	yield takeEvery(SET_REPORT_DEADLINE_SUCCESS, setReportDeadlineSuccess);
	yield takeEvery(SET_REPORT_DEADLINE_ERROR, setReportDeadlineError);
	yield takeEvery(SET_REPORT_RESUBMISSION_SUCCESS, setReportResubmissionSuccess);
	yield takeEvery(SET_REPORT_RESUBMISSION_ERROR, setReportResubmissionError);
	yield takeEvery(STOP_OBSERVING_REPORT_SUCCESS, stopObservingReportSuccess);
	yield takeEvery(STOP_OBSERVING_REPORT_ERROR, stopObservingReportError);
	yield takeEvery(ASSIGN_REPORT_SUCCESS, assignReportSuccess);
	yield takeEvery(ASSIGN_REPORT_ERROR, assignReportError);
	yield takeEvery(CREATE_NEW_REPORT_SUCCESS, createNewReportSuccess);
	yield takeEvery(CREATE_NEW_REPORT_ERROR, createNewReportError);
	yield takeEvery(SHOW_NEW_REPORT_GET_ADDRESS_ERROR, showNewReportGetAddressError);
	yield takeEvery(CREATE_NEW_ISSUE_SUCCESS, createNewReportSuccess);
	yield takeEvery(CREATE_NEW_ISSUE_ERROR, createNewReportError);
}

export function* organisationProfileNotifications() {
	yield takeEvery(ADD_ORGANISATION_CONTACT_SUCCESS, addOrganisationContactSuccess);
	yield takeEvery(ADD_ORGANISATION_CONTACT_ERROR, addOrganisationContactError);
	yield takeEvery(UPDATE_ORGANISATION_CONTACT_SUCCESS, updateOrganisationContactSuccess);
	yield takeEvery(UPDATE_ORGANISATION_CONTACT_ERROR, updateOrganisationContactError);
	yield takeEvery(DELETE_ORGANISATION_CONTACT_SUCCESS, deleteOrganisationContactSuccess);
	yield takeEvery(DELETE_ORGANISATION_CONTACT_ERROR, deleteOrganisationContactError);
	yield takeEvery(UPDATE_ORGANISATION_DATA_SUCCESS, commonUpdateSuccess);
	yield takeEvery(UPDATE_ORGANISATION_DATA_ERROR, commonUpdateError);
	yield takeEvery(UPDATE_ORGANISATION_SETTINGS_SUCCESS, commonUpdateSuccess);
	yield takeEvery(UPDATE_ORGANISATION_SETTINGS_ERROR, commonUpdateError);
	yield takeEvery(ADD_ORGANISATION_GROUP_SUCCESS, addOrganisationGroupSuccess);
	yield takeEvery(ADD_ORGANISATION_GROUP_ERROR, addOrganisationGroupError);
	yield takeEvery(ADD_ORGANISATION_USER_SUCCESS, addOrganisationUserSuccess);
	yield takeEvery(ADD_ORGANISATION_USER_ERROR, addOrganisationUserError);
	yield takeEvery(UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_SUCCESS, commonUpdateSuccess);
	yield takeEvery(UPDATE_ORGANISATION_MELDOO_APP_SETTINGS_ERROR, commonUpdateError);
	yield takeEvery(ADD_ORGANISATION_APP_USER_CONNECTION_SUCCESS, addOrganisationAppUserConnectionSuccess);
	yield takeEvery(ADD_ORGANISATION_APP_USER_CONNECTION_ERROR, addOrganisationAppUserConnectionError);
	yield takeEvery(REMOVE_ORGANISATION_APP_USER_CONNECTION_SUCCESS, removeOrganisationAppUserConnectionSuccess);
	yield takeEvery(REMOVE_ORGANISATION_APP_USER_CONNECTION_ERROR, removeOrganisationAppUserConnectionError);
	yield takeEvery(REMOVE_ORGANISATION_USER_SUCCESS, removeOrganisationUserSuccess);
}

export function* reportCitizenNotifications() {
	yield takeEvery(REPORT_CITIZEN_SUCCESS, reportCitizenSuccess);
	yield takeEvery(REPORT_CITIZEN_ERROR, reportCitizenError);
}

export function* userProfileNotifications() {
	yield takeEvery(UPDATE_USER_PASSWORD_SUCCESS, updateUserPasswordSuccess);
	yield takeEvery(UPDATE_USER_PASSWORD_ERROR, updateUserPasswordError);
}

function* updateUserPasswordSuccess() {
	successNotification('passwordExpiredModal.updatePassword.success');
}

function* updateUserPasswordError({ payload }) {
	if (payload.error !== 'oldPasswordInvalid') errorNotification('passwordExpiredModal.updatePassword.error', payload.error);
}

export function* authNotifications() {
	yield takeEvery(RESTORE_PASSWORD_ERROR, restorePasswordError);
	yield takeEvery(SIGNIN_USER_ERROR, signInUserError);
	yield takeEvery(TOKEN_EXPIRED, tokenExpired);
}

function* restorePasswordError({ payload }) {
	errorNotification('restorePasswordPage.error', payload.error);
}

function* signInUserError({ payload }) {
	if (payload.error === 'Bitte melden Sie sich bei MeldooPLUS 3.0 an.')
		return swal({
			text: 'Ihr Zugang ist für MeldooPLUS 3.0 freigeschaltet. Bitte melden Sie sich dort mit Ihren bestehenden Benutzerdaten an.',
			icon: 'info',
			button: 'Zu Version 3.0'
		}).then(() => {
			window.location.href = 'https://www.meldooplus.de/v3/login';
		});

	NotificationManager.error(
		payload.error,
		<IntlMessages id={payload.error === 'loginInvalid' ? 'loginPage.signIn.loginInvalid' : 'loginPage.signIn.error'} />,
		5000
	);

	// errorNotification(payload.error === 'loginInvalid' ? 'loginPage.signIn.loginInvalid' : 'loginPage.signIn.error', payload.error, 'Test');
}

function* tokenExpired() {
	warningNotification('loginPage.tokenExpired', 'loginPage.tokenExpiredInfo');
}

export function* commonNotifications() {
	yield takeEvery(COMMON_UPDATE_SUCCESS, commonUpdateSuccess);
	yield takeEvery(COMMON_UPDATE_ERROR, commonUpdateError);
	yield takeEvery(COMMON_ERROR, commonError);
	yield takeEvery(COMMON_SUCCESS, commonSuccess);
}

function* commonUpdateSuccess() {
	successNotification('common.changesSaved.success');
}

function* commonUpdateError({ payload }) {
	errorNotification('common.changesSaved.error', payload.error);
}

function* commonError({ payload }) {
	errorNotification(
		'notifications.defaultTitle',
		payload && payload.error ? payload.error : '',
		payload && payload.errorTitle ? payload.errorTitle : undefined
	);
}

function* commonSuccess({ payload }) {
	successNotification(payload.message, true);
}

export default function* RootSaga() {
	yield all([
		fork(reportNotifications),
		fork(organisationProfileNotifications),
		fork(reportCitizenNotifications),
		fork(userProfileNotifications),
		fork(authNotifications),
		fork(commonNotifications)
	]);
}



// WEBPACK FOOTER //
// ./sagas/Notifications.js